import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mixes: [{ tranches: [{}] }],
};

const mixesSlice = createSlice({
  name: 'mixes',
  initialState,
  reducers: {
    setMixes: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.mixes = action.payload;
    },
    addMix: (state) => {
      state.mixes.push({ tranches: [{}] });
    },
    removeMix: (state, action) => {
      state.mixes.splice(action.payload, 1);
    },
    addTrancheToMix: (state, action) => {
      const { mixIndex } = action.payload;
      if (state.mixes[mixIndex]) {
        state.mixes[mixIndex].tranches.push({});
      }
    },
    removeTrancheFromMix: (state, action) => {
      const { mixIndex, trancheIndex } = action.payload;
      if (state.mixes[mixIndex] && state.mixes[mixIndex].tranches.length > 1) {
        state.mixes[mixIndex].tranches.splice(trancheIndex, 1);
      }
    },
    updateTranche: (state, action) => {
      const { mixIndex, trancheIndex, trancheData } = action.payload;
      if (state.mixes[mixIndex] && state.mixes[mixIndex].tranches[trancheIndex]) {
        // eslint-disable-next-line no-param-reassign
        state.mixes[mixIndex].tranches[trancheIndex] = {
          ...state.mixes[mixIndex].tranches[trancheIndex],
          ...trancheData,
        };
      }
    },
    resetMixes: () => initialState,
  },
});

export { initialState };
export const {
  setMixes,
  addMix,
  removeMix,
  addTrancheToMix,
  removeTrancheFromMix,
  updateTranche,
  resetMixes,
} = mixesSlice.actions;

export default mixesSlice.reducer;
